export default "__VITE_ASSET__Cna0aAOZ__"